import { FC } from 'react';
import { HeaderModel } from '../../../models/CommonModel';
import SortableColumn from '../../../components/Table/SortableColumn';
import { formatPrice } from '../../../selectors';
import { WarehouseRowModel } from '../../../models/account-books/WarehousesAccount';
import moment from 'moment';
import { removeTrailingZeros } from '../../../modules/common/helper';

type Props = {
    data: Array<WarehouseRowModel>,
    header: HeaderModel[]
    hideCols: string[],
    openColConfig: () => void,
    handleSort: (sortBy: string, direction: 'asc' | 'desc' | 'none') => void
    openingStockLine?: WarehouseRowModel
};

const WarehousesAccountTable: FC<Props> = ({ data, header, hideCols, openColConfig, handleSort, openingStockLine }) => {
    const typeDesc: Record<string, string> = {
        sale: 'Xuất bán',
        receipt: 'Nhập hàng',
        checksheet: 'Kiểm kho',
        refund: 'Trả hàng'
    }

    return (
        <div className='table-responsive'>
            <table className="table table-hover table-bordered table-striped border gy-7 gs-7">
                <thead>
                    <tr className="fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200">
                        <th>
                            <i 
                                className="fa fa-cogs"
                                style={{cursor: 'pointer'}}
                                onClick={openColConfig}
                            ></i>
                        </th>
                        {header.map((th, index) => {
                            if (!hideCols.includes(th.field)) {
                                if (th.sortable) {
                                    return (
                                        <SortableColumn
                                            key={'th-' + index}
                                            sortBy={th?.field}
                                            onSortChange={handleSort}
                                            style={th?.style ?? {}}
                                        >
                                            {th.label}
                                        </SortableColumn>
                                    )
                                }
                                return (
                                    <th style={th?.style ?? {}}>{th.label}</th>
                                )
                            }
                        })}
                    </tr>
                </thead>
                <tbody>
                    {openingStockLine && (
                        <tr className={`cursor-pointer text-primary`}>
                            <td></td>
                            {!hideCols.includes('invoice_date') && (
                            <td>
                            </td>
                            )}
                            {!hideCols.includes('invoice_code') && (
                            <td>
                               
                            </td>
                            )}
                            {/* {!hideCols.includes('voucher_no') && (
                            <td>{item?.voucher_no ?? ''}</td>
                            )} */}
                            {!hideCols.includes('product_code') && (
                            <td >{openingStockLine.product_code}</td>
                            )}
                            {!hideCols.includes('product_name') && (
                            <td >{openingStockLine.product_name}</td>
                            )}
                            {!hideCols.includes('qty_in') && (
                            <td >{'-'}</td>
                            )}
                            {!hideCols.includes('qty_out') && (
                            <td >{'-'}</td>
                            )}
                            {!hideCols.includes('cumulative_stock') && (
                            <td className={'text-center ' + ('text-success')}>
                                {formatPrice(openingStockLine.cumulative_stock ?? 0)}
                            </td>
                            )}
                            {!hideCols.includes('unit_cost') && (
                            <td >{formatPrice(openingStockLine.unit_cost ?? 0)}</td>
                            )}
                            {!hideCols.includes('sell_price') && (
                            <td >{formatPrice(openingStockLine.sell_price ?? 0)}</td>
                            )}
                            {!hideCols.includes('line_amount') && (
                            <td >{formatPrice((openingStockLine.cumulative_stock ?? 0) * (openingStockLine.unit_cost ?? 0))}</td>
                            )}
                            {!hideCols.includes('type') && (
                            <td className='text-danger fw-bold'>Tồn đầu kỳ</td>
                            )}
                        </tr>
                    )}
                    {data?.map((item: WarehouseRowModel, index: number) => {
                        let qty = item.qty_in > 0 ? item.qty_in :  item.qty_out;
                        let rowAmount = qty * (item.unit_cost ?? 0);
                        const cumulativeStock = item.cumulative_stock ?? 0;
                        const sellPrice = item.sell_price ?  formatPrice(item.sell_price) : null
                        const direction = item.qty_in > 0 ? 'in' : 'out' 
                        
                        return (
                            <tr key={`agent_${index}`} className={`cursor-pointer` + (cumulativeStock < 0 ? ' bg-light-danger' : '') + (direction === 'out' ? ' text-primary' : '')}>
                                <td></td>
                                {!hideCols.includes('invoice_date') && (
                                <td>
                                    {item.invoice_date ? moment(item.invoice_date, 'YYYY-MM-DD').format('DD-MM-YYYY') : ''}
                                </td>
                                )}
                                {!hideCols.includes('invoice_code') && (
                                <td>
                                    {item.invoice_code ?? ''}
                                </td>
                                )}
                                {/* {!hideCols.includes('voucher_no') && (
                                <td>{item?.voucher_no ?? ''}</td>
                                )} */}
                                {!hideCols.includes('product_code') && (
                                <td >{item.product_code}</td>
                                )}
                                {!hideCols.includes('product_name') && (
                                <td >{item.product_name}</td>
                                )}
                                {!hideCols.includes('qty_in') && (
                                <td >{item.qty_in && item.qty_in > 0 ? formatPrice(removeTrailingZeros(item.qty_in), false) : '-'}</td>
                                )}
                                {!hideCols.includes('qty_out') && (
                                <td >{item.qty_out && item.qty_out > 0 ? formatPrice(removeTrailingZeros(item.qty_out), false) : '-'}</td>
                                )}
                                {!hideCols.includes('cumulative_stock') && (
                                <td className={'text-center ' + (cumulativeStock < 0 ? 'text-danger' : 'text-success')}>
                                    {formatPrice(cumulativeStock)}
                                    {cumulativeStock < 0 && (
                                        <i className='fa fa-exclamation-triangle text-danger'></i>
                                    )}
                                </td>
                                )}
                                {!hideCols.includes('unit_cost') && (
                                <td >{formatPrice(item.unit_cost ?? 0)}</td>
                                )}
                                {!hideCols.includes('sell_price') && (
                                <td >{sellPrice}</td>
                                )}
                                {!hideCols.includes('line_amount') && (
                                <td >{formatPrice(rowAmount)}</td>
                                )}
                                {!hideCols.includes('type') && (
                                <td >{typeDesc[item.type] ?? item.type}</td>
                                )}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    );
}

export default WarehousesAccountTable;